import React from "react";
import cx from "classnames";
import { ThemeStore } from "@foris/avocado-suite";
import { Icon, IconTypes } from "@foris/avocado-icons";
import styles from "./linkRouter.module.scss";
import { Link } from "react-router-dom";

export interface LinkRouterProps
  extends Omit<
    React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>,
    "ref" | "href"
  > {
  to: string;
  /** Render content link */
  children: React.ReactNode | string;
  /** Overwrite className */
  className?: string;
  /** Set a color  */
  colored?: boolean;
  /** Set disabled value */
  disabled?: boolean;
  /** Set icon left */
  iconLeft?: IconTypes;
  /** Set icon right */
  iconRight?: IconTypes;
  /** Use size 'sm' or 'md'. Default 'md' */
  size?: "sm" | "md";
  /** Handle onClock event */
  onClick?: () => void;
}

const LinkRouter = ({
  children,
  className,
  disabled = false,
  iconLeft,
  iconRight,
  size = "md",
  colored = false,
  onClick,
  ...otherLinkProps
}: LinkRouterProps) => {
  const themeMode = ThemeStore.useThemeStore(state => state.theme.mode);

  return (
    <Link
      {...otherLinkProps}
      className={cx(
        styles.linkRouter,
        disabled && styles.linkRouter__disabled,
        size === "sm" && styles.linkRouter__sm,
        colored === true && styles.linkRouter__colored,
        themeMode === "dark" && styles.linkRouter__darkMode,
        className && className,
      )}
      onClick={() => {
        if (!disabled) {
          onClick && onClick();
        }
      }}
      tabIndex={disabled ? -1 : 0}
    >
      {iconLeft && <Icon name={iconLeft} size={size} className={styles.linkRouter_iconLeft} />}
      <span className={styles.linkRouter_content}>{children}</span>
      {iconRight && <Icon name={iconRight} size={size} className={styles.linkRouter_iconRight} />}
    </Link>
  );
};

export default LinkRouter;
